<script>
import CockpitMatryoshkaInheritanceTree
from '@/components/cockpit/matryoshka/inheritance-tree/CockpitMatryoshkaInheritanceTree.vue';

export default {
  name: 'CockpitMatryoshkaItemContentsTab',
  props: {
    labelArchiveId: Number,
    orderId: Number,
  },
  emits: [
    'connections-updated',
    'go-to-serial-number',
  ],
  components: {
    CockpitMatryoshkaInheritanceTree,
  },
};
</script>

<template>
  <div class="h-100">
    <CockpitMatryoshkaInheritanceTree
      :label-archive-id="labelArchiveId"
      :init-order-id="orderId"
      @connections-updated="$emit('connections-updated', $event)"
      @go-to-serial-number="$emit('go-to-serial-number', $event)"
    />
  </div>
</template>

<style scoped lang="scss">

</style>
